import NeuroIdScript from './NeuroIdScript'

export default NeuroIdScript
